export function scrollToElement(
  container: HTMLElement,
  element: Element,
): void {
  // On mobile, expand the outermost section and all its descendants
  if (window.matchMedia("(max-width: 640px)").matches) {
    let topSection: Element | null = element.closest(
      'section[data-mw-section-id]:not([data-mw-section-id="0"])',
    );
    let parent =
      topSection?.parentElement?.closest(
        'section[data-mw-section-id]:not([data-mw-section-id="0"])',
      ) ?? null;
    while (parent) {
      topSection = parent;
      parent =
        topSection.parentElement?.closest(
          'section[data-mw-section-id]:not([data-mw-section-id="0"])',
        ) ?? null;
    }
    if (topSection) {
      topSection.classList.add("expanded");
      topSection
        .querySelectorAll("section[data-mw-section-id]")
        .forEach((s) => s.classList.add("expanded"));
    }
  }
  const elRect = element.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();
  const scrollTop = elRect.top - containerRect.top + container.scrollTop;
  container.scrollTo({ top: scrollTop, behavior: "instant" });
}
